import roundPortfolioTradeValue from 'src/components/PortfolioPage/utils/roundPortfolioTradeValue';

interface Params {
	cumulativeRealizedPnl: number | undefined;
	unrealizedPnl: number | undefined;
	cumulativeFunding: number | undefined;
	cumulativeFeePaid: number | undefined;
	cumulativeFeeRebate: number | undefined;
	includeFeesAndFunding: boolean;
	realizedPnlOnly: boolean;
}

export default function computePortfolioPnlValues({
	cumulativeRealizedPnl,
	unrealizedPnl,
	cumulativeFunding,
	cumulativeFeePaid,
	cumulativeFeeRebate,
	includeFeesAndFunding,
	realizedPnlOnly,
}: Params) {
	let totalPnl = roundPortfolioTradeValue(cumulativeRealizedPnl ?? 0);

	const feesAndFunding = roundPortfolioTradeValue(
		(cumulativeFunding ?? 0) -
			(cumulativeFeePaid ?? 0) +
			(cumulativeFeeRebate ?? 0)
	);

	if (includeFeesAndFunding) {
		totalPnl += feesAndFunding;
	}

	if (!realizedPnlOnly) {
		totalPnl += roundPortfolioTradeValue(unrealizedPnl ?? 0);
	}

	return { totalPnl, feesAndFunding };
}
